import styled from '@emotion/styled'
import { Grid } from '@mui/material'

import { theme } from 'styles/theme/hav-theme'

type FieldWrapperProps = {
  templateColumns: string
}

export const Container = styled('div')`
  padding-bottom: ${theme.spacing['2xl']};
`

export const GridRowStyled = styled('div')`
  margin: auto;
  margin-top: ${theme.spacing.sm};
  display: grid;
  grid-auto-flow: row;
  row-gap: ${theme.spacing.xm};

  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-top: ${theme.spacing.xm};
  }
`

export const GridColumnStyled = styled('div')`
  margin: auto 0;
  width: fit-content;
  display: grid;
  grid-auto-flow: column;
  column-gap: ${theme.spacing.sm};
  align-items: center;

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    grid-auto-flow: row;
    column-gap: 0;
    row-gap: ${theme.spacing.sm};
  }
`

export const WrapTopActionsStyled = styled(Grid)`
  @media only screen and (max-width: ${theme.breakpoints.md}px) {
    margin-top: ${theme.spacing.md};
  }

  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    display: none;
  }
`

export const ColumnTopCampStyled = styled('div')`
  height: fit-content;
  display: grid;
  grid-auto-flow: row;
  row-gap: ${theme.spacing['2xl']};
  width: 100%;
  margin-bottom: ${theme.spacing['2xl']};

  #TopCampTitle {
    font-size: ${theme.typography.sizes.xl};
    font-family: ${theme.typography.family.primary};
    font-weight: ${theme.typography.weight.lg};
    line-height: normal;
    color: ${theme.colors.neutral.medium};
    @media only screen and (max-width: ${theme.breakpoints.sm}px) {
      font-size: ${theme.typography.sizes['2md']};
    }
  }
  @media only screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-bottom: ${theme.spacing.md};
  }
`

export const OrderConfig = styled.div`
  display: grid;
  grid-gap: ${theme.spacing.lg};
`

export const FieldWrapper = styled.div<FieldWrapperProps>`
  display: grid;
  grid-template-columns: ${(props) => props.templateColumns};
  grid-gap: ${theme.spacing.lg};
  width: 100%;

  .fieldItemWrapper {
    display: flex;
    flex-direction: column;
  }

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    grid-template-columns: 1fr 1fr;
  }
`

export const OrderByAvailableDeliveryDatesWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.lg};

  @media only screen and (max-width: ${theme.breakpoints.lg}px) {
    flex-direction: column;
    align-items: inherit;
  }
`

export const OrderByAvailableDeliveryDates = styled.div`
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background: ${theme.colors.quartenary};

  div {
    width: ${theme.spacing.xm};
    margin: ${theme.spacing.xs} ${theme.spacing.md} 0;
  }

  p {
    margin: ${theme.spacing.md};
  }
`

export const PrioritizeFactories = styled.div`
  display: flex;
  flex-direction: column;

  .label {
    display: flex;
    align-items: center;
  }
`

export const ConfigHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['2xl']};
`

export const StatisticsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  margin: -5px 0 ${theme.spacing.md} 0;
  gap: ${theme.spacing.md};
`
export const InnerRow = styled.div`
  display: flex;
  max-width: 100%;
  align-items: center;
  gap: ${theme.spacing.xm};
`
export const Box = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: start;
  gap: ${theme.spacing.xs};
`
export const BoxTitle = styled.span`
  display: block;
  color: ${theme.colors.neutral.medium};
  font-size: ${theme.typography.sizes.xs};
  font-weight: ${theme.typography.weight.lg};
`
export const BoxValue = styled.span`
  display: block;
  color: ${theme.colors.neutral.high};
  font-size: ${theme.typography.sizes.sm};
  font-weight: ${theme.typography.weight.xsm};
`

export const BoxRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`

export const AlertWrapper = styled.div`
  margin-bottom: ${theme.spacing.md};
`
